import { forwardRef, Ref, type SVGProps } from 'react'

const SvgUserCross = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 16 15"
    role="img"
    ref={ref}
    {...props}
  >
    <path
      stroke={props.color || `currentColor`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.167 3.333a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0M9.667 10.417c0 1.61-1.866 2.916-4.167 2.916s-4.167-1.306-4.167-2.916C1.333 8.806 3.2 7.5 5.5 7.5s4.167 1.306 4.167 2.917"
      clipRule="evenodd"
    />
    <path
      fill={props.color || `currentColor`}
      d="M11.864 1.136a.75.75 0 0 0-1.061 1.061zm.606 2.728a.75.75 0 1 0 1.06-1.06zm1.06-1.06a.75.75 0 1 0-1.06 1.06zm.606 2.726a.75.75 0 0 0 1.061-1.06zm-.606-1.666a.75.75 0 0 0-1.06-1.06zm-2.727.606a.75.75 0 1 0 1.06 1.06zm1.667-1.667a.75.75 0 0 0 1.06 1.06zm2.727-.606a.75.75 0 1 0-1.06-1.06zm-4.394 0 1.667 1.667 1.06-1.06-1.666-1.668zm1.667 1.667 1.666 1.666 1.061-1.06-1.667-1.667zm0-1.06L10.803 4.47l1.06 1.06 1.667-1.666zm1.06 1.06 1.667-1.667-1.06-1.06-1.667 1.666z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgUserCross)
export default ForwardRef
